import queryString from 'query-string';
import {
	FILTER_INVESTMENT_TYPE,
	FILTER_RISK_LEVEL,
	FILTER_GROUP_SLUG,
	DEFAULT_SORT,
	DEFAULT_INVESTMENT_TYPE,
	DEFAULT_PAGE_SIZE,
} from 'stash/constants/investmentFilters';

export type InvestmentSearchParams = Record<
	string,
	string | number | boolean | Array<string | number> | null | undefined
>;

export type FilterParamValue = string | number | Array<string | number>;

export type InvestmentsBrowseFilter = {
	key: string;
	values: string[];
};

export type InvestmentsBrowseParams = {
	page: number;
	page_size: number;
	sort: string;
	filter: InvestmentsBrowseFilter[];
};

// Converts various query param formats to array
export function parseFilterValues(
	filterParam: FilterParamValue | null | undefined,
	fallback: string[] = []
): string[] {
	if (!filterParam && filterParam !== 0) return fallback;
	if (typeof filterParam === 'string' || typeof filterParam === 'number') {
		return [String(filterParam)];
	}
	return filterParam.map(String);
}

export function getParams(
	search: InvestmentSearchParams = {},
	page = 0
): InvestmentsBrowseParams {
	return {
		page,
		page_size: DEFAULT_PAGE_SIZE,
		sort: (search.sort as string) || DEFAULT_SORT,
		filter: [
			{
				key: FILTER_INVESTMENT_TYPE,
				values: parseFilterValues(search.investment_type as FilterParamValue, [
					DEFAULT_INVESTMENT_TYPE,
				]),
			},
			{
				key: FILTER_RISK_LEVEL,
				values: parseFilterValues(search.risk_level as FilterParamValue),
			},
			{
				key: FILTER_GROUP_SLUG,
				values: parseFilterValues(search.investment_group_slug as FilterParamValue),
			},
		],
	};
}

export function stringifyParams(search: InvestmentSearchParams): string {
	return queryString.stringify(search, { arrayFormat: 'comma', sort: false });
}

export function getSearchUrl(): string {
	const search = window.location.search;
	return search.replace(/\?/, '');
}
